import { ConcessionariaModel } from './../../app/models/ConcessionariaModel';
import { Injectable } from '@angular/core';
import { ConfigHelper } from '../../app/helpers/configHelper';
import { Storage } from '@ionic/storage';
import { HttpProvider } from '../http/http';
import { AlertProvider } from '../../providers/alert/alert';


@Injectable()
export class ConfiguracaoConcessionariaProvider {
  constructor(
    public storage: Storage,
    private httpSrv: HttpProvider,
    private alertSrv: AlertProvider
  ) {}

  public async isLogado() {
    return await this.storage.get(ConfigHelper.storageKeys.codConcessionaria);
  }

  public async isConcessionaria() {
    return await this.storage.get(ConfigHelper.storageKeys.concessionaria);
  }

  public async logout() {
    // this.storage.clear().then(() => {});

    //estee console exibe todo o conteudo presente no storage
    // const keys = await this.storage.keys();
    // console.log('Contents of Storage:');
    // for (const key of keys) {
    //   const value = await this.storage.get(key);
    //   console.log(key, ':', value);
    // }

    //aqui eu removo agora somente o conteudo sensivel, o resto fica no storage
    this.storage.set('usuario', '');
    this.storage.set('token', '');
    this.storage.set('idUsuario', '');
  }

  async autenticar(model: any): Promise<ConcessionariaModel> {
    try {
      let ResultConn = await this.httpSrv.postApi("authApp", model);
      if (ResultConn.success) {
        if (ResultConn.data.login) {
          return ResultConn.data;
        } else {
          this.alertSrv.alert("FALHA AO LOGAR", ResultConn.data.message);
        }
      }
    } catch (error) {
      console.log(
        "problema ao autenticar provider configuracao - concessionaria",
        error
      );
    }
  }

  async gravaLog(log) {
    try {
      let ResultConn = await this.httpSrv.postApi("v1/gravaLog", log, 9999999, 1);
      if (ResultConn) {
      }
    } catch (error) {
      console.log("Problema ao gravar LOG", error);
    }
  }

  public atualizaLoja(loja){
    this.storage.set(ConfigHelper.storageKeys.concessionaria, JSON.stringify(loja));
  }
}



// WEBPACK FOOTER //
// ./src/providers/configuracao-concessionaria/configuracao-concessionaria.ts